/**
 * set csair app navigation Bar title
 * @param {string} title
 */
export default function setAppHeaderTitle(title) {
    try {
        window.CSNativeObject.nativeSetTitle(title || '');
    }
    catch (e) { }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/setAppHeaderTitle.js
// module id = null
// module chunks = 